import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { solutionStats } from '../../data/site';
import { lessonPhases } from '../../data/lessons';
import { padNumber } from '../../utils/format';
export function Solution() {
  let lessonNumber = 0;
  return <section aria-labelledby="solution-title" className="bg-deepest py-20 text-white lg:py-24" data-id="element-261" data-mp="3rcx5g6mzm452">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-262" data-mp="97afoxfzkpmx">
        <SectionHeading id="solution-title" eyebrow="The solution" lead="Meet" highlight="Handball Class Ready" intro="A complete, ready-to-teach team handball unit for PE teachers and new school or youth coaches working with children aged 8–11. Every lesson shows what to set up, what to say and what to look for — so you can walk in and teach." data-id="element-263" data-mp="498wmcik8qbg" />

        <ul className="mt-12 grid grid-cols-2 border border-white/15 lg:grid-cols-4" data-id="element-264" data-mp="nx85tixh7per">
          {solutionStats.map((stat, index) => <li key={stat.label} className={`bg-pine/60 px-3 py-7 text-center ${index % 2 === 1 ? 'border-l border-white/15' : ''} ${index > 1 ? 'border-t border-white/15 lg:border-t-0' : ''} ${index === 2 ? 'lg:border-l' : ''}`} data-id="element-265" data-mp="1vvi3t4zgng29" data-mpi={index}>
              <span className="block font-display text-[52px] font-bold leading-none text-gold sm:text-[64px]" data-id="element-266" data-mp="29v10n1mtn4z9">
                {stat.value}
              </span>
              <span className="mt-2 block text-[12px] font-bold uppercase tracking-[0.14em] text-white/80 sm:text-[13px]" data-id="element-267" data-mp="2iuo37qraegtw">
                {stat.label}
              </span>
            </li>)}
        </ul>

        <h3 className="mt-16 text-center font-display text-[30px] font-bold uppercase leading-none sm:text-[36px]" data-id="element-268" data-mp="2skz6rc726o09">
          A clear 12-lesson progression
        </h3>
        <ol className="relative mt-10 grid gap-8 lg:grid-cols-4 lg:gap-6" data-id="element-269" data-mp="32iwt1u5cyaq8">
          <span aria-hidden="true" className="absolute bottom-2 left-[19px] top-2 w-0.5 bg-gold/35 lg:bottom-auto lg:left-0 lg:right-0 lg:top-[19px] lg:h-0.5 lg:w-auto" data-id="element-270" data-mp="32j5a7y8ik278" />
          {lessonPhases.map((phase, phaseIndex) => <li key={phase.range} className="relative pl-16 lg:pl-0 lg:pt-16" data-id="element-271" data-mp="2mkt6a1qip0xp" data-mpi={phaseIndex}>
              <span aria-hidden="true" className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full border-2 border-gold bg-deepest font-display text-xl font-bold text-gold" data-id="element-272" data-mp="2htb1f2ldig7g">
                {phaseIndex + 1}
              </span>
              <p className="text-[13px] font-bold uppercase tracking-[0.14em] text-gold" data-id="element-273" data-mp="35jylsnch6yaw">{phase.range}</p>
              <p className="mt-1 font-display text-[26px] font-bold uppercase leading-tight" data-id="element-274" data-mp="30k2i6p7ox8vv">{phase.title}</p>
              <ul className="mt-3 space-y-1.5" data-id="element-275" data-mp="1b6fj6z3l8piq">
                {phase.lessons.map(lesson => {
              lessonNumber += 1;
              return <li key={lesson} className="flex gap-2.5 text-base text-white/80" data-id="element-276" data-mp="3htwo80cb8217">
                      <span className="w-6 shrink-0 font-bold tabular-nums text-white" data-id="element-277" data-mp="3hw0sije4f320">{padNumber(lessonNumber)}</span>
                      {lesson}
                    </li>;
            })}
              </ul>
            </li>)}
        </ol>

        <div className="mt-14 text-center" data-id="element-278" data-mp="3d13jhcguctp4">
          <CtaButton target="offer" className="w-full sm:w-auto" data-id="element-279" data-mp="2z3exg1b1fgih">
            See what’s included
          </CtaButton>
        </div>
      </div>
    </section>;
}